module.exports = __webpack_public_path__ + "assets/webgl/card_083_EN_L0.d0d1ab82.jpg";